<template>
  <popup :opened="show" :no-close-button="true" @close="$emit('close')">
    <div class="my-15 flex flex-col items-center space-y-10 min-h-screen">
      <h4 class="text-indigo-600">Filtres {{ tab }}</h4>

      <div
        v-if="filters.beneficiaries.length > 0 && tab === 'Bénéficiaires'"
        class="flex flex-col space-y-2"
      >
        <InputText
          libelle="Nom du groupe"
          placeholder="Donnez un nom au nouveau groupe"
          :value="groupName"
          @input="newValue => groupName = newValue"
        >
        </InputText>
        <div v-if="groupName === undefined || groupName === ''" class="text-sm text-red-500">
          Veuillez donner un nom au nouveau groupe
        </div>

        <ActionButton
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-white"
          icon-color="text-indigo-600"
          icon="plus"
          :responsive="true"
          libelle="Créer un nouveau groupe à partir de la sélection"
          @clickAction="createGroup"
          :is-disabled="groupName === undefined || groupName === ''"
        >
        </ActionButton>
      </div>

      <div class="place-self-start w-full">
        <beneficiaries-filter
          v-if="tab === 'Bénéficiaires'"
          :filter="filters.beneficiaries"
          @updateBeneficiariesFilter="
            (beneficiariesFilter) => {
              $emit('updateBeneficiariesFilter', beneficiariesFilter);
            }
          "
          :groups="userGroups"
          @groupDeleted="loadGroups"
        />
        <competences-filter
          class="md:mx-15"
          v-if="tab === 'Compétences'"
          :filter="filters.competences"
          :templates="templates"
          @updateCompetencesPersoFilter="
            (competencesFilter) => {
              $emit('updateCompetencesPersoFilter', competencesFilter);
            }
          "
          @updateCompetencesSocioFilter="
            (competencesFilter) => {
              $emit('updateCompetencesSocioFilter', competencesFilter);
            }
          "
          @updateCompetencesProFilter="
            (competencesFilter) => {
              $emit('updateCompetencesProFilter', competencesFilter);
            }
          "
        />
      </div>

      <div class="flex space-x-5">
        <action-button
          v-if="tab === 'Compétences'"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          :libelle="'Précédent'"
          :uppercase="true"
          icon="arrow-circle-left"
          type-shadow="shadow-pink"
          :right="false"
          @clickAction="previousStep"
        />

        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          :libelle="tab === 'Bénéficiaires' ? 'Suivant' : 'Valider'"
          :uppercase="true"
          :icon="
            tab === 'Bénéficiaires'
              ? 'arrow-circle-right'
              : 'checkmark-circle-2'
          "
          type-shadow="shadow-pink"
          :right="true"
          @clickAction="nextStep"
        />
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import ActionButton from '../../../components/ActionButton.vue';

import BeneficiariesFilter from './BeneficiariesFilter.vue';
import CompetencesFilter from './CompetencesFilter.vue';
import axios from 'axios';
import InputText from '../../../components/Inputs/InputText.vue';

export default {
  name: 'FiltersCompetences',
  props: {
    show: Boolean,
    filters: Object,
    templates: Array,
  },

  components: {
    InputText,
    Popup,
    ActionButton,
    BeneficiariesFilter,
    CompetencesFilter,
  },

  data() {
    return {
      tab: 'Bénéficiaires',
      userGroups: [],
      groupName: undefined,
    };
  },

  methods: {
    nextStep() {
      if (this.tab === 'Bénéficiaires') {
        this.tab = 'Compétences';
        return;
      }

      if (this.tab === 'Compétences') {
        this.$emit('close');
      }
    },

    previousStep() {
      this.tab = 'Bénéficiaires';
    },

    async createGroup() {
      if (this.groupName === undefined) {
        return;
      }

      await axios.post('/api/userGroup', {
        users: this.selectedBeneficiariesIds,
        name: this.groupName,
      });

      await this.loadGroups();
    },


    async loadGroups() {
      const response = await axios.get('/api/userGroup');
      this.userGroups = response.data;
    }
  },

  computed: {
    selectedBeneficiariesIds() {
      return this.filters.beneficiaries.map((b) => b.id);
    },
  },

  mounted() {
    this.loadGroups();
  },
};
</script>
